import styled from 'styled-components';

import { mediaWide } from '@xingternal/layout-tokens';
import { space3XL, spaceS, spaceXL, spaceXXL } from '@xingternal/tokens';
import { BodyCopy, Headline } from '@xingternal/typography';

export const CreateAlertLightboxContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spaceXL};
  text-align: center;
  padding: ${space3XL} ${spaceXL};
`;

export const CreateAlertLightboxHeadline = styled(Headline)`
  margin-bottom: ${spaceS};
`;

export const CreateAlertLightboxParagraph = styled(BodyCopy)`
  margin-bottom: 0;
`;

export const CreateAlertLightboxButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceS};
`;

export const CreateAlertLightboxLOContent = styled.div`
  @media ${mediaWide} {
    margin: 0 ${spaceXXL};
  }
`;
